<template>
  <div v-show="isShow" id="id" class="floatBtn_PC">
    <span @click="goToChat()">
      <i class="fa fa-weixin" aria-hidden="true"></i>
    </span>
    <span class="newMsg" v-if="newMsgNum>0">{{newMsgNum}}</span>
  </div>
</template>

<script>
export default {
  name: "ChatBtn",
  data() {
    return {
      newMsgNum: 0,
      getMsgInterval: null,
      stopDataIntervalFlag: false,
    };
  },
  computed: {
    chatUrl: function() {
      return myutil.chat_url + "/?token=" + this.$store.state.token;
      if (window.location.host.search("80") != -1) {
        // 本地开发
        return "http://192.168.1.8:8091/?token=" + this.$store.state.token;
      } else {
        return "https://chat.firstffc.com/?token=" + this.$store.state.token;
      }
    },
    isShow: function() {
      var that = this;
      return that.$store.state.isLogin && !that.$store.state.pcFlag;
      setTimeout(function() {
        // console.log(myutil.pcFlag, that.$store.state.isLogin,'dasd', !myutil.pcFlag && that.$store.state.isLogin);
        // return (!myutil.pcFlag && that.$store.state.isLogin)
      }, 100);
    }
  },
  mounted: function() {
    var that = this;

    setTimeout(function() {
      if (!myutil.pcFlag) {
        (function() {
          var _x_start,
            _y_start,
            _x_move,
            _y_move,
            _x_end,
            _y_end,
            left_start,
            top_start;
          //按下
          document
            .getElementById("id")
            .addEventListener("touchstart", function(e) {
              _x_start = e.touches[0].pageX; //起始点击位置
              _y_start = e.touches[0].pageY; //起始点击位置
              left_start = $("#id").css("left"); //元素左边距
              top_start = $("#id").css("top"); //元素上边距
            });
          //移动
          document
            .getElementById("id")
            .addEventListener("touchmove", function(e) {
              e.preventDefault(); //取消事件的默认动作。
              _x_move = e.touches[0].pageX; //当前屏幕上所有触摸点的集合列表
              _y_move = e.touches[0].pageY; //当前屏幕上所有触摸点的集合列表
              //左边距=当前触摸点-鼠标起始点击位置+起始左边距
              $("#id").css(
                "left",
                parseFloat(_x_move) -
                  parseFloat(_x_start) +
                  parseFloat(left_start) +
                  "px"
              );
              //上边距=当前触摸点-鼠标起始点击位置+起始上边距
              $("#id").css(
                "top",
                parseFloat(_y_move) -
                  parseFloat(_y_start) +
                  parseFloat(top_start) +
                  "px"
              );
            });
          //松开
          document
            .getElementById("id")
            .addEventListener("touchend", function(e) {
              var bodyW = $(window).width() / 2; //屏幕宽的一半
              var bodyH = $(window).height(); //屏幕高
              var _x_end = e.changedTouches[0].pageX; //松开位置
              var _y_end = e.changedTouches[0].pageY; //松开位置
              var divH = $("#id").height(); //元素高
              var divW = $("#id").width(); //元素宽
              //当最终位置在屏幕左半部分
              if (_x_end < bodyW) {
                $("#id").css("left", "0px");
              } else if (_x_end >= bodyW) {
                //当最终位置在屏幕左半部分
                $("#id").css("left", $(window).width() - parseFloat(divW));
              }
              //当元素顶部在屏幕外时
              if (parseFloat($("#id").css("top")) < 0) {
                //置于顶部
                $("#id").css("top", 0); //置于顶部
              }
              //当元素底部在屏幕外时
              if (bodyH - _y_end < parseFloat(divH) / 2) {
                //置于底部
                $("#id").css("top", bodyH - parseFloat(divH));
              }
            });
          $("#id").click(function() {
            console.log("点击");
          });
        })();
      }
    }, 100);

    if (that.getMsgInterval) {
      that.getMsgInterval = null;
    }

    that.stopDataIntervalFlag = false
    setTimeout(function(){
        that.stopDataIntervalFlag = false
      },1000*10)

    this.getUnread();
    this.getMsgInterval = setInterval(function() {
      that.getUnread();
    }, 1000 * 1); 
  },
  destroyed() {
    clearInterval(this.getMsgInterval);
  },
  methods: {
    getUnread: function(){
      var that = this;
      if(!that.$store.state.isLogin){
        return
      }
      if(!myutil.pcFlag){  // 手机才可以
        return
      }
      if(that.stopDataIntervalFlag){
        console.log('请求太频繁');
        return
      }
      that.stopDataIntervalFlag = true

      setTimeout(function(){

        var _url = myutil.base_url + "/user/chat_unread_count";

        $.get({
          url: _url,
          success: function(res, status, xhr) {
            if(xhr.status == 200){
              that.stopDataIntervalFlag = false
            }
            that.newMsgNum = Number(res);
          },
          error: function(result) {
            that.stopDataIntervalFlag = true;
          }
        });
         
      },1000)
    },
    goToChat: function() {

      this.$router.push({
          path: "/Chat",
        });
        return


      if (myutil.pcFlag) {
        window.open(this.chatUrl, "_blank");
      } else {
        this.$router.push({
          path: "/Chat",
          query: {
            token: this.$store.state.token
          }
        });
      }
    },
    goTo: function(_path) {
      this.$router.push({
        path: _path
      });
    }
  }
};
</script>

<style lang="less" scoped>
.newMsg {
  background: red;
  padding: 2px;
  color: #fff;
  border-radius: 66px;
  position: relative;
  left: -9px;
  top: -14px;
}
.floatBtn_PC {
  width: 50px;
  height: 50px;
  line-height: 65px;
  text-align: center;
  background: rgb(230, 224, 224);
  color: rgb(97, 214, 68);
  position: fixed;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 50%;
  overflow: hidden;
  z-index: 999999;
  left: 0;
  top: 150px;
  i {
    font-size: 30px;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/ChatBtn.vue